var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import IconWrapper from "./IconWrapper";
export default React.forwardRef((_a, ref) => {
    var { color = "secondary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { d: "M14.3511 5.35925L3.3468 16.3643C3.29144 16.4199 3.25146 16.49 3.23243 16.5653L2.0127 21.461C1.97622 21.6084 2.01953 21.7651 2.12708 21.8727C2.20846 21.954 2.31934 21.9991 2.43276 21.9991C2.4675 21.9991 2.50304 21.9948 2.53762 21.9861L7.43332 20.7662C7.50962 20.7472 7.57894 20.7073 7.6343 20.652L18.6395 9.6477L14.3511 5.35925Z" }),
        React.createElement("path", { d: "M21.3657 3.8587L20.1408 2.63375C19.3221 1.81505 17.8952 1.81584 17.0775 2.63375L15.577 4.13424L19.8652 8.42253L21.3657 6.92204C21.7747 6.51324 21.9999 5.96914 21.9999 5.39045C21.9999 4.81176 21.7747 4.26765 21.3657 3.8587Z" })));
});
//# sourceMappingURL=Edit.js.map